"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = ["id"];
const _hoisted_2 = { style: { "border-bottom": "1px solid #d9d0c7" } };
const _hoisted_3 = { key: 0 };
const _hoisted_4 = { class: "event_type" };
const _hoisted_5 = { key: 1 };
const _hoisted_6 = {
    key: 0,
    class: "event_name"
};
const _hoisted_7 = { key: 2 };
const _hoisted_8 = { class: "event_time" };
const _hoisted_9 = { key: 1 };
const _hoisted_10 = { class: "vehicle_status" };
const _hoisted_11 = { key: 2 };
const _hoisted_12 = { class: "speed" };
const _hoisted_13 = { key: 3 };
const _hoisted_14 = { class: "temperature1" };
const _hoisted_15 = { class: "temperature2" };
const _hoisted_16 = { class: "temperature3" };
const _hoisted_17 = { class: "temperature4" };
const _hoisted_18 = { key: 4 };
const _hoisted_19 = { class: "event_time" };
const moment_1 = __importDefault(require("moment"));
const vue_3 = require("vue");
const BssMapLatLng_vue_1 = __importDefault(require("./BssMapLatLng.vue"));
const category_key = 'e_infobox_settings';
exports.default = (0, vue_1.defineComponent)({
    __name: 'BssMapEventInfobox',
    props: {
        data: {},
        movementSettings: {}
    },
    setup(__props) {
        var _a;
        const props = __props;
        const messages = (0, vue_3.inject)('messages');
        const id = `${props.data.event_type}_${props.data.id}`;
        const infobox_messages = messages.e_infobox;
        const checkMovementSetting = window.checkMovementSetting;
        const event_id_status_message = (0, vue_3.computed)(() => props.data.event_status == 1 ? '（予冷）' : props.data.event_status == 2 ? '（積置）' : '');
        const event_time = (0, vue_3.computed)(() => {
            let _event_time = '';
            if (props.data.end_time != null && props.data.time != props.data.end_time) {
                const diff = new Date(props.data.end_time).getTime() - new Date(props.data.time).getTime();
                const day = Math.floor(diff / 86400000);
                let hour = Math.floor((diff % 86400000) / 3600000);
                const min = Math.round(((diff % 86400000) % 3600000) / 60000);
                if (min > 0) {
                    let hstr = '';
                    if (day > 0) {
                        hour += day * 24;
                    }
                    if (hour > 0) {
                        hstr = hour + '時間';
                    }
                    _event_time += '（' + hstr + min + '分）';
                }
            }
            return _event_time;
        });
        const time_and_end_time = (0, vue_3.computed)(() => {
            const _time = (0, moment_1.default)(props.data.time).format('MM/DD HH:mm');
            let _end_time = '';
            if (props.data.end_time != null && props.data.time != props.data.end_time) {
                const diff = new Date(props.data.end_time).getTime() - new Date(props.data.time).getTime();
                const min = Math.round(((diff % 86400000) % 3600000) / 60000);
                if (min > 0) {
                    _end_time = ' 〜 ' + (0, moment_1.default)(props.data.end_time).format('MM/DD HH:mm');
                }
            }
            return _time + _end_time;
        });
        const t1 = (0, vue_3.computed)(() => props.data.temp1 != null && props.data.temp1 != '32767' && props.data.temp1 != '32766'
            ? (Number(props.data.temp1 + 0) / 10).toString()
            : props.data.temperature1 != null && props.data.temperature1 != '3276.7' && props.data.temperature1 != '3276.6'
                ? props.data.temperature1
                : '---');
        const t2 = (0, vue_3.computed)(() => props.data.temp2 != null && props.data.temp2 != '32767' && props.data.temp2 != '32766'
            ? (Number(props.data.temp2 + 0) / 10).toString()
            : props.data.temperature2 != null && props.data.temperature2 != '3276.7' && props.data.temperature2 != '3276.6'
                ? props.data.temperature2
                : '---');
        const t3 = (0, vue_3.computed)(() => props.data.temp3 != null && props.data.temp3 != '32767' && props.data.temp3 != '32766'
            ? (Number(props.data.temp3 + 0) / 10).toString()
            : props.data.temperature3 != null && props.data.temperature3 != '3276.7' && props.data.temperature3 != '3276.6'
                ? props.data.temperature3
                : '---');
        const t4 = (0, vue_3.computed)(() => props.data.temp4 != null && props.data.temp4 != '32767' && props.data.temp4 != '32766'
            ? (Number(props.data.temp4 + 0) / 10).toString()
            : props.data.temperature4 != null && props.data.temperature4 != '3276.7' && props.data.temperature4 != '3276.6'
                ? props.data.temperature4
                : '---');
        const updated_at = (0, vue_3.computed)(() => (0, moment_1.default)(props.data.updated_at).format('YYYY/MM/DD HH:mm:ss'));
        const section_id = ((_a = props.data) === null || _a === void 0 ? void 0 : _a.section_id) || '';
        const is_visible_item1 = (0, vue_3.computed)(() => checkMovementSetting(section_id, category_key, 'event_type', props.movementSettings)); // 1.イベント区分
        const is_visible_item2 = (0, vue_3.computed)(() => checkMovementSetting(section_id, category_key, 'event_name', props.movementSettings)); // 2.イベント名
        const is_visible_item3 = (0, vue_3.computed)(() => checkMovementSetting(section_id, category_key, 'event_id', props.movementSettings)); // 3.イベント種別
        const is_visible_item4 = (0, vue_3.computed)(() => checkMovementSetting(section_id, category_key, 'time', props.movementSettings)); // 4.発生日時
        const is_visible_item5 = (0, vue_3.computed)(() => checkMovementSetting(section_id, category_key, 'latlon', props.movementSettings)); // 5.緯度・経度
        const is_visible_item6 = (0, vue_3.computed)(() => checkMovementSetting(section_id, category_key, 'vehicle_status', props.movementSettings)); // 6.車両状態
        const is_visible_item7 = (0, vue_3.computed)(() => checkMovementSetting(section_id, category_key, 'speed', props.movementSettings)); // 7.速度
        const is_visible_item8 = (0, vue_3.computed)(() => checkMovementSetting(section_id, category_key, 'temperature', props.movementSettings)); // 8.温度
        const is_visible_item9 = (0, vue_3.computed)(() => checkMovementSetting(section_id, category_key, 'updated_at', props.movementSettings)); // 9.最終更新日時
        function getEventTypeMessage(event_type, messages) {
            const _event_type = (event_type || '').toString();
            let message = _event_type;
            if (messages.event_types.hasOwnProperty(_event_type)) {
                message = messages.event_types[_event_type];
            }
            return message;
        }
        function getEventIdMessage(event_id, messages) {
            const _event_id = (event_id || '').toString();
            let message = _event_id;
            if (messages.event_id_messages.hasOwnProperty(_event_id)) {
                message = messages.event_id_messages[_event_id];
            }
            return message;
        }
        function getVehicleStatusMessage(vehicle_status, luggage_status, messages) {
            let message = '';
            const _vehicle_status = (vehicle_status || '').toString();
            const _luggage_status = (luggage_status || '').toString();
            if (messages.vehicle_status_types.hasOwnProperty(_vehicle_status)) {
                message += messages.vehicle_status_types[_vehicle_status];
            }
            if (_vehicle_status == '1' && messages.luggage_status_types.hasOwnProperty(_luggage_status)) {
                message += '(' + messages.luggage_status_types[_luggage_status] + ')';
            }
            return message;
        }
        return (_ctx, _cache) => {
            var _a, _b;
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                id: `infobox_event_${id}`,
                style: { "color": "#89684f" }
            }, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (is_visible_item1.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_3, [
                            (0, vue_2.createElementVNode)("span", _hoisted_4, "[" + (0, vue_2.toDisplayString)(getEventTypeMessage(_ctx.data.event_type, (0, vue_2.unref)(messages))) + "]", 1)
                        ]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (is_visible_item2.value || is_visible_item3.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_5, [
                            (is_visible_item2.value)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_6, (0, vue_2.toDisplayString)(getEventIdMessage(_ctx.data.event_id, (0, vue_2.unref)(messages))) + (0, vue_2.toDisplayString)(event_id_status_message.value) + (0, vue_2.toDisplayString)(event_time.value), 1))
                                : (0, vue_2.createCommentVNode)("", true)
                        ]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (is_visible_item4.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_7, [
                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(infobox_messages).time) + ": ", 1),
                            (0, vue_2.createElementVNode)("span", _hoisted_8, (0, vue_2.toDisplayString)(time_and_end_time.value), 1)
                        ]))
                        : (0, vue_2.createCommentVNode)("", true)
                ]),
                (0, vue_2.createElementVNode)("div", null, [
                    (is_visible_item5.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(BssMapLatLng_vue_1.default, {
                            key: 0,
                            latitude: _ctx.data.latitude,
                            longitude: _ctx.data.longitude
                        }, null, 8, ["latitude", "longitude"]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (is_visible_item6.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_9, [
                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(infobox_messages).vehicle_status) + ": ", 1),
                            (0, vue_2.createElementVNode)("span", _hoisted_10, (0, vue_2.toDisplayString)(getVehicleStatusMessage(_ctx.data.vehicle_status, _ctx.data.luggage_status, (0, vue_2.unref)(messages))), 1)
                        ]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (is_visible_item7.value && ((_a = _ctx.data.average_speed) !== null && _a !== void 0 ? _a : _ctx.data.speed))
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_11, [
                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(infobox_messages).speed) + ": ", 1),
                            (0, vue_2.createElementVNode)("span", _hoisted_12, (0, vue_2.toDisplayString)((_b = _ctx.data.average_speed) !== null && _b !== void 0 ? _b : _ctx.data.speed) + "km/h", 1)
                        ]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (is_visible_item8.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_13, [
                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(infobox_messages).temperature_name1) + ": ", 1),
                            (0, vue_2.createElementVNode)("span", _hoisted_14, (0, vue_2.toDisplayString)(t1.value), 1),
                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(infobox_messages).temperature_deg) + ", " + (0, vue_2.toDisplayString)((0, vue_2.unref)(infobox_messages).temperature_name2) + ": ", 1),
                            (0, vue_2.createElementVNode)("span", _hoisted_15, (0, vue_2.toDisplayString)(t2.value), 1),
                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(infobox_messages).temperature_deg) + ", " + (0, vue_2.toDisplayString)((0, vue_2.unref)(infobox_messages).temperature_name3) + ": ", 1),
                            (0, vue_2.createElementVNode)("span", _hoisted_16, (0, vue_2.toDisplayString)(t3.value), 1),
                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(infobox_messages).temperature_deg) + ", " + (0, vue_2.toDisplayString)((0, vue_2.unref)(infobox_messages).temperature_name4) + ": ", 1),
                            (0, vue_2.createElementVNode)("span", _hoisted_17, (0, vue_2.toDisplayString)(t4.value), 1),
                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(infobox_messages).temperature_deg), 1)
                        ]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (is_visible_item9.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_18, [
                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(infobox_messages).updated_at) + ": ", 1),
                            (0, vue_2.createElementVNode)("span", _hoisted_19, (0, vue_2.toDisplayString)(updated_at.value), 1)
                        ]))
                        : (0, vue_2.createCommentVNode)("", true)
                ])
            ], 8, _hoisted_1));
        };
    }
});
